//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            isActive: this.$route.path, //默认值为路由取下来的
        }
    },
    //生命周期之挂载完成
    methods: {
        goPath(val){
            this.$router.push({path: '/'+val,query: {source: 'commNav'}});
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/nav/index.vue